import { captureError, captureMessage } from "./sentry";

/**
 * Secure logging utility that logs in development mode
 * and sends errors/warnings to Sentry in production
 */
export const logger = {
  /**
   * Log an error - will be sent to Sentry in production
   */
  error: (message: string, error?: Error | unknown, context?: Record<string, unknown>) => {
    if (import.meta.env.DEV) {
      console.error(message, error, context);
    }
    
    // Send to Sentry in production
    if (error instanceof Error) {
      captureError(error, { message, ...context });
    } else if (error) {
      captureError(new Error(message), { originalError: error, ...context });
    } else {
      captureMessage(message, "error");
    }
  },

  /**
   * Log a warning - will be sent to Sentry in production
   */
  warn: (message: string, context?: Record<string, unknown>) => {
    if (import.meta.env.DEV) {
      console.warn(message, context);
    }
    captureMessage(message, "warning");
  },

  /**
   * Log info - only in development, not sent to Sentry
   */
  log: (...args: unknown[]) => {
    if (import.meta.env.DEV) {
      console.log(...args);
    }
  },

  /**
   * Log info message - sent to Sentry as info level
   */
  info: (message: string, context?: Record<string, unknown>) => {
    if (import.meta.env.DEV) {
      console.info(message, context);
    }
    captureMessage(message, "info");
  },
};
